import React, { useState, useContext } from 'react';

import { useTheme, HStack } from 'native-base';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Context } from '../contexts/GlobalContext';
import { fontSizes, lineHeights, letterSpacings } from '../styles/fonts';
import { Button } from './../components/Button';
import MoonIcon from '../assets/icons/MoonIcon';
import SunIcon from '../assets/icons/SunIcon';
import PrivacyPolicyIcon from '../assets/icons/PrivacyPolicyIcon';
import { RouteProp, ParamListBase } from '@react-navigation/native';

import { PrivacyPolicy } from '../screens/PrivacyPolicy';


export function AppRoutes() {



  const { colors } = useTheme();

  const { state, setState } = useContext(Context);
  const { Navigator, Screen } = createBottomTabNavigator();
  const [isLoadingLogout, setIsLoadingLogout] = useState(false);
  const [isLoadingScheme, setIsLoadingScheme] = useState(false);

  async function handleLogout() {
    await setIsLoadingLogout(true);
    await setIsLoadingLogout(false);
  }

  async function handleColorScheme() {
    await setIsLoadingScheme(true);
    await setState({
      colorScheme:
        state.colorScheme === 'dark' ?
          'light' : 'dark'
    }
    );
    await setIsLoadingScheme(false);
  }

  function screenOptions(route: RouteProp<ParamListBase, string>) {
    return {
      tabBarActiveTintColor: colors.Label.Plain,
      tabBarInactiveTintColor: colors.Label.Secondary,
      headerTitleAlign: 'left',
      headerTitleAllowFontScaling: true,
      headerTitleStyle: {
        fontFamily: 'LargeTitleBold',
        fontSize: fontSizes.LargeTitle,
        lineHeight: lineHeights.LargeTitle,
        letterSpacing: letterSpacings.LargeTitle,
      },
      headerRight: () => (
        <HStack>
          {/*  <ButtonSelectImage/> */}
          {
            <Button
              type='Plain'
              onPress={handleColorScheme}
              isDisabled={isLoadingScheme}
              isLoading={isLoadingScheme}
              Icon={
                <>
                  {state.colorScheme === 'dark' ?
                    <SunIcon fill={colors.Label.Plain} /> :
                    <MoonIcon fill={colors.Label.Plain} />
                  }
                </>
              }
            />
          }


        </HStack>
      ),
      tabBarLabelStyle: {
        fontFamily: 'Caption2Bold',
        fontSize: fontSizes.Caption2,
        lineHeight: lineHeights.Caption2,
        letterSpacing: letterSpacings.Caption2,
      }
    }
  };

  return (
    <Navigator
      screenOptions={({ route }) =>
        screenOptions(route)
      }
    >
      <Screen
        name={`Policies`}
        component={PrivacyPolicy}
        options={({ navigation: { goBack } }) => ({
          tabBarLabel: 'Policies',
          tabBarIcon: ({ color }) => <PrivacyPolicyIcon fill={color} />,
          /* headerLeft: () => (
            <Button
              ml={0}
              type={'Plain'}
              onPress={() => goBack()}
              Icon={<LeftIcon fill={colors.Label.Plain} />}
            />
          ), */
        })}
      />
    </Navigator >
  )
}//PrivacyPolicyIcon